// localStorage that never throws (private mode, blocked storage).
export const storage = {
  get(k: string, area: Storage | undefined = globalThis.localStorage): string | null {
    try {
      return area?.getItem(k) ?? null;
    } catch {
      return null;
    }
  },
  set(k: string, v: string, area: Storage | undefined = globalThis.localStorage) {
    try {
      area?.setItem(k, v);
    } catch {
      /* ignore */
    }
  },
  remove(k: string, area: Storage | undefined = globalThis.localStorage) {
    try {
      area?.removeItem(k);
    } catch {
      /* ignore */
    }
  },
};
